<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { productTypeFields } from "../../utils/TableFields/product-type.fields";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./product-type.store";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="prodotto"
    entityPlural="prodotti"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  />

  <Table
    loading={$loading}
    fields={productTypeFields}
    records={$records}
    pagination={$pagination}
    createEnabled={false}
    editEnabled={true}
    deleteEnabled={false}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
